<template>
    <div>
        <CallAlert ref="callAlert"></CallAlert>
        <section class="section section-shaped my-0 overflow-hidden pt-4">
            <div class="shape shape-style-3 bg-gradient-default shape-skew"></div>
            <div class="container pb-250">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Контакты</h2>
                        <p class="text-white">
                            CADFlo (ООО «КАДФло») — инженерно-консалтинговая компания,<br>
                            на сегодняшний момент активно занимается разработкой и поставкой<br> инженерных решений для промышленных предприятий.
                        </p>
                    </div>
                </div>
                <div class="row justify-content-center mt-3">
                    <div class="col-lg-8">
                        <div class="row text-center">
                            <div class="col-lg-4">
                                <icon name="fa fa-phone" gradient="white" shadow round color="default"></icon>
                                <h5 class="text-white mt-3">Телефон</h5>
                                <p class="text-white mt-3">
                                    {{$root.phone}}
                                </p>
                            </div>
                            <div class="col-lg-4">
                                <icon name="fa fa-address-card" gradient="white" shadow round color="default"></icon>
                                <h5 class="text-white mt-3">Адрес</h5>
                                <p class="text-white mt-3">
                                    {{$root.address}}
                                </p>
                            </div>
                            <div class="col-lg-4">
                                <icon name="fa fa-envelope" gradient="white" shadow round color="default"></icon>
                                <h5 class="text-white mt-3">Почта</h5>
                                <p class="text-white mt-3">
                                    {{$root.email}}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <base-input class="mt-3"
                                        alternative
                                        :placeholder="placeholder.name"
                                        addon-left-icon="ni ni-user-run"
                                        v-model="form.name" :valid="validation"
                                        @keydown.space.prevent>
                            </base-input>
                            <base-input alternative
                                        :placeholder="placeholder.email"
                                        :valid="validationEmail"
                                        v-model="form.email"
                                        addon-left-icon="ni ni-email-83"
                                        @keydown.space.prevent>
                            </base-input>
                            <base-input class="mb-4">
                                <textarea class="form-control form-control-alternative" name="name" rows="4"
                                          cols="80" placeholder="Сообщение..."
                                          v-model="form.message"></textarea>
                            </base-input>
                            <base-button type="default" round block v-on:click="sendMessage('Форма обратной связи')">
                                Отправить
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import CallAlert from "@/components/CallAlert.vue";
export default {
  name: "contactForm",
  components: {
      CallAlert
  },
  data() {
    return {
        form: {
            name: '',
            email: '',
            message: ''
        },
        placeholder: {
            name: 'Имя',
            email: 'Email'
        },
        validation: null,
        validationEmail: null,
    };
  },
  methods: {
      sendMessage(title) {
        this.validation = null;
        this.validationEmail = null;

        if (this.form.name == '') {
            this.placeholder.name = 'Имя должно быть заполнено';
            this.validation = false;
        }
        if (this.form.email == '') {
            this.placeholder.email = 'Email должен быть заполнен';
            this.validationEmail = false;
        }
        if ((this.form.name != '') 
            && (this.form.email != '')) {
            var params = {
                params: {
                    title: title,
                    name: this.form.name,
                    email: this.form.email,
                    message: this.form.message,
                }
            };
            this.$axios
                .get('/rest/message/', params)
                .then(response => {
                    this.$refs.callAlert.showAlert();
                    this.form.name = '';
                    this.form.email = '';
                    this.form.message = '';
                    this.placeholder.name = 'Имя';
                    this.placeholder.email = 'Email';
                });
        }
      }
  }
};
</script>
<style>
</style>
